module.exports = __webpack_public_path__ + "img/UGA.406f9b76.svg";